import React, { useState } from 'react'
import { FaRegSmileWink } from "react-icons/fa";
import { GiThumbUp } from "react-icons/gi";
import { MdOutlineMailLock } from "react-icons/md";
import { FaXTwitter } from "react-icons/fa6";
import { FaWhatsappSquare } from "react-icons/fa";
import { AiFillPhone } from "react-icons/ai";
import "../css/sayhi.css"

const SayHi = () => {
const [showHi, setShowHi]= useState(false)

const handleshowHi =()=>{
  setShowHi(!showHi);
}
const handleDontshowHi=()=>{
 return  !setShowHi(showHi);
}

const handleemail=()=>{
    window.location = "mailto:missionaryabraham@yahoo.com";
  }

  const handleemail2=()=>{
    window.location = "mailto:missionaryabra@gmail.com";
  }

   const phoneNumber = +2347046818032
   const phoneNumber2 = +2349069186158
   const urlTwitter  = "https://twitter.com/home"



  return (
    <div className='sayhiContainer'>
      <div className='sayhiMain'>


      <div onMouseLeave={handleshowHi} onMouseEnter={handleDontshowHi} className='sayhiIntro'>
         {
          showHi ? (<div>
           <p>Say hi</p>
            <GiThumbUp />
          </div>) : (<div>
            <p>Say hi</p>
           <FaRegSmileWink />
          </div>)
         }
      </div>
      
      <div className='sayhibody1'>
        we working together is just a message away, we can schedule an appointment via any of the means below
      </div>

      {/* icon flex */}

      <div className='sayhibody2'>
        <div >
        <MdOutlineMailLock />
          <p onClick={handleemail} className=' cursor-pointer'>missionaryabraham@yahoo.com</p>
        </div>

        <div >
        <MdOutlineMailLock />
        <p onClick={handleemail2} className=' cursor-pointer'>missionaryabra@gmail.com</p>
        </div>

        <div>
          <AiFillPhone></AiFillPhone>
          <p className=' cursor-pointer'><a href={`tel: ${phoneNumber} `}>+234 704 6818 032</a></p>
        </div>
        <div>

          <FaWhatsappSquare />
          <p className=' cursor-pointer'><a href={`tel: ${phoneNumber2} `}>+234 906 9186 158</a></p>
        </div>
        <div>
        <FaXTwitter />
        <p className=' cursor-pointer'><a href={urlTwitter} target='_blank' rel="noreferrer">Twitter</a></p>
        </div>

      </div>

      <div className='finalsayhidiv'>
        <p>I look forward to hearing from you soon.</p>
        <p className='leftp'>Thank you</p>
      </div>

      </div>
    </div>
  )
}

export default SayHi
